/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Buying_Group_InvalidInputs */

const en_error_buying_group_invalid = /** @type {(inputs: Error_Buying_Group_InvalidInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The buying group cannot be saved as it is:`)
};

/**
* | output |
* | --- |
* | "The buying group cannot be saved as it is:" |
*
* @param {Error_Buying_Group_InvalidInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_buying_group_invalid = /** @type {((inputs?: Error_Buying_Group_InvalidInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Buying_Group_InvalidInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_buying_group_invalid(inputs)
});